import RenderCards from './render-cards';

export default RenderCards;